export const partnersReg = {
  seo: {
    title: "Partner Registration - Bespire",
    description: "Join the Bespire partner network and let's build a stronger creator ecosystem together!",
    keywords: "partner registration, partnership application, Bespire partners, creator platform"
  },
  navigation: {
    back: "Back"
  },
  hero: {
    title: "Partner Registration",
    description: "Join the Bespire partner network and let's build a stronger creator ecosystem together!"
  },
  form: {
    title: "Partner Application Form",
    description: "Please fill out the form below as accurately as possible",
    
    companyInfo: {
      title: "Company Information",
      companyName: {
        label: "Company Name",
        placeholder: "e.g. Creative Studio Ltd."
      },
      website: {
        label: "Website",
        placeholder: "https://www.mycompany.com"
      },
      companyDescription: {
        label: "Company Description",
        placeholder: "Brief description of your company and main activities..."
      }
    },
    
    contactInfo: {
      title: "Contact Information",
      contactPerson: {
        label: "Contact Person Name",
        placeholder: "John Smith"
      },
      position: {
        label: "Position/Role",
        placeholder: "Select your position",
        options: {
          tulajdonos: "Owner",
          ugyvezeto: "Managing Director",
          ertekesitesiVezeto: "Sales Manager",
          marketingVezeto: "Marketing Manager",
          uzletfejlesztesiVezeto: "Business Development Manager",
          termekMenedzser: "Product Manager",
          projektMenedzser: "Project Manager",
          ertekesitesiKepviselo: "Sales Representative",
          marketingSzakerto: "Marketing Specialist",
          ugyfelKapcsolatiMenedzser: "Customer Relationship Manager",
          egyeb: "Other"
        }
      },
      email: {
        label: "Email Address",
        placeholder: "john@mycompany.com"
      },
      phone: {
        label: "Phone Number",
        placeholder: "+1 555 123 4567"
      }
    },
    
    partnershipDetails: {
      title: "Partnership Details",
      serviceType: {
        label: "Service Type",
        placeholder: "Select service",
        options: {
          webDesign: "Web Design",
          marketing: "Marketing",
          consulting: "Consulting",
          development: "Development",
          content: "Content Creation",
          training: "Training"
        }
      },
      experience: {
        label: "Experience (in years)",
        placeholder: "Select",
        options: {
          "1-2": "1-2 years",
          "3-5": "3-5 years",
          "6-10": "6-10 years",
          "10+": "10+ years"
        }
      },
      expectedVolume: {
        label: "Expected Monthly Volume",
        placeholder: "Select",
        options: {
          "1-5": "1-5 clients",
          "6-15": "6-15 clients",
          "16-30": "16-30 clients",
          "30+": "30+ clients"
        }
      },
      previousClients: {
        label: "Previous Clients/References",
        placeholder: "Briefly describe your previous projects and clients..."
      }
    },
    
    terms: {
      accept: "I accept the",
      generalTerms: "General Terms and Conditions",
      and: "and the",
      privacyPolicy: "Privacy Policy",
      required: "*"
    },
    
    submit: {
      button: "Submit Application",
      submitting: "Submitting..."
    },
    
    validation: {
      termsRequired: "Please accept the terms to continue!"
    },
    
    messages: {
      success: "Application submitted successfully! We will contact you soon!",
      error: "An error occurred during submission. Please try again!",
      termsComingSoon: "Terms and Privacy Policy coming soon!",
      privacyComingSoon: "Privacy Policy coming soon!"
    }
  }
};